/**
 * KiMap - Simple Drawing Animation Background
 */
export default function LoginBackground() {
  return (
    <div className="drawing-bg">
      {/* Grid background - full screen */}
      <div className="grid-bg"></div>

      <style>{`
        .drawing-bg {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          overflow: hidden;
        }

        .grid-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: 
            linear-gradient(#ccc 1px, transparent 1px),
            linear-gradient(90deg, #ccc 1px, transparent 1px);
          background-size: 40px 40px;
          opacity: 0.3;
        }
      `}</style>
    </div>
  );
}
